import { useTheme } from "../context/ThemeContext";

// `title` is optional and renders as the native tooltip — used where a pill is
// an abbreviation of something longer (e.g. a channel showing only its UDP port,
// with the full udp://ip:port on hover).
export default function Pill({ label, title }) {
  const { mode } = useTheme();
  return (
    <span title={title} style={{ background:"var(--surface-alt)", border:`1px solid var(--border)`, borderRadius:4, padding:"2px 7px", fontSize:11, fontWeight:500, color:"var(--text-sub)", fontFamily:"'IBM Plex Mono', monospace" }}>
      {label}
    </span>
  );
}
